import projectsPageEn from "./ProjectsPage/projectsPageEn";

const textEn = {
  en: {
    menu: {
      home: "Home",
      projects: "Projects",
      about: "About",
    },
    introduction: {
      introPt1: "The communication we create today is the impact we reap tomorrow!",
      introPt2: "We want to walk alongside those who are transforming realities, crafting narratives that inform, mobilize, and inspire new ways of being. Because communication is a powerful tool to shape new worldviews and build the future we envision!",
      button: "More +",
    },
    instaFeed: {
      title: "NEWS"
    },
    footer: {
      info: "Site by Utópika Estúdio Criativo"
    },
    aboutPage: {
      intro: {
        title: 'To Utopiar is to transform the future',
        paragraph1: `Here at Utópika, we believe that communication is a tool for transformation and part of the solution to the challenges we face in the world!`,
        paragraph2: `Our commitment is to tell stories that matter, amplify voices that need to be heard, and create campaigns that spark real change. We work at the intersection of creativity and impact, building images that carry purpose.`,
        paragraph3: `We walk alongside organizations, social movements, and brands that are reimagining the present to transform the future. We want to be close and united in building narratives that bring solutions, imagination, and purpose.`,
        paragraph4: `From immersive exhibitions to graphic campaigns, from visual identity to animation, our team mobilizes to give shape to ideas that move the world.`,
        paragraph5: `Design can — and should — be on the right side of history. Shall we make it happen?`,
      },
      profile: {
        julia: {
          name: 'Julia Lima',
          role: 'Partner and Creative Director',
          text: `Designer, illustrator, and motion designer. With over a decade of experience, she works at the intersection of design, narrative,
          and social impact. She sees design as a collective practice committed to reality, capable of amplifying voices and building
          meaningful connections. She works with exhibition design and game design, translating complex themes into accessible experiences.
          At Utópika, she leads teams and projects that combine clarity, imagination, and transformation. She believes that design only makes
          sense when it has the courage to interfere in the world.`,
          hasImage: true
        },
        rachel: {
          name: 'Rachel Gepp',
          role: 'Partner and Creative Director',
          text: `Advertising professional, designer, and illustrator. She combines creative intelligence with practical repertoire to develop
          projects with critical vocation and social impact. At Utópika, she creates visual identities and graphic content for social,
          cultural, and environmental organizations, translating complex issues for diverse audiences. She uses design as a tool for
          provocation, mobilization, and change. She believes that communicating with honesty is a political act.`,
          hasImage: true
        },
        ana: {
          name: 'Ana Clara',
          role: 'Designer',
          text: `She has participated in outreach and research projects, consolidating a transdisciplinary and critical view of design. Even in the
          face of setbacks and conservative discourses, she maintains a proactive perspective and believes in communication as a power for
          transformation. At Utópika, she contributes to projects that reflect diversity, listening, and commitment to the future. She
          believes that collective and plural design is a force for mobilization.`,
          hasImage: false
        },
        mauricio: {
          name: 'Maurício Boff',
          role: 'Strategic Partner at Utópika',
          text: `Communication and socio-environmental facilitation consultant, writer, and strategic partner at Utópika. He has worked for over
          15 years with impact strategies in conservation, regeneration, and climate justice projects in South America. Driven by listening
          and intercultural dialogue, he works to turn discourse into concrete change. He believes that to communicate is to connect worlds
          and plant seeds of future possibilities.`,
          hasImage: false
        },
      },
      socialMedia: {
        julia: {
          instagram: "https://www.instagram.com/jotalimac/",
          linkedin: "https://www.linkedin.com/in/julia-lima/",
        },
        rachel: {
          instagram: "https://www.instagram.com/gepprachel/",
          linkedin: "https://www.linkedin.com/in/rachelgepp/",
        },
      },
      clients: {
        title: "Clients",
      }
    },
    projectsPage: projectsPageEn,
  }
};

export default textEn;
